





















































































import { Component, Vue, Inject, Watch } from "vue-property-decorator";
import Footer from "../components/Footer.vue";
import TenantSwitch from "../components/tenant-switch.vue";
import LanguageSwitch from "../components/language-switch.vue";
import iView from "view-design";
import AbpBase from "../lib/abpbase";
import Util from "../lib/util";
// import WxLogin from "../lib/wxlogin";
import User from "../store/entities/user";
import Ajax from "../lib/ajax";
import appconst from "../lib/appconst";
import newCoupon from "@/components/new-coupon.vue";

@Component({
    components: { Footer, TenantSwitch, LanguageSwitch, newCoupon },
})
export default class Login extends AbpBase {
    loginModel = {
        userNameOrEmailAddress: "",
        password: "",
        rememberMe: false,
    };
    showChangeTenant: boolean = false;
    bindPhoneModal: boolean = false;
    user: User = new User();
    content: string = "获取验证码";
    disabled: boolean = false;
    isShow: boolean = false;
    code: number = 0;
    userInfo: any;
    url:string=""

    async login() {
        (this.$refs.loginform as any).validate(async (valid: boolean) => {
            if (valid) {
                this.$Message.loading({
                    content: this.L("LoginPrompt"),
                    duration: 0,
                });
                await this.$store
                    .dispatch({
                        type: "app/login",
                        data: this.loginModel,
                    })
                    .then((res) => { });
                sessionStorage.setItem(
                    "rememberMe",
                    this.loginModel.rememberMe ? "1" : "0"
                );
                //location.reload();
                // await this.$store.dispatch({
                //     type: "session/init"
                // });
                const url = window.localStorage.getItem('detail');
                if (url) {
                    window.location.href = url;
                    window.localStorage.removeItem('detail')
                } else {
                    //   let routeName = "fronthome";
                      let isRegister = this.$store.state.session.user.isRegister;

                    if (this.$store.state.session.user && isRegister === false) {
                     let routeName = "home"; 
                    this.$router.push({ name: routeName });
                    }

                }
             

                this.$Message.destroy();
            }
        });
    }
    toForget() {
        this.$router.push({ name: "forget" });
    }
    // wechatHandleClick() {
    //     let ba64Css = "css代码base64编码"; // 微信需要https的样式路径，这里将样式内容加密base64，可以避免使用https，如果你的网站是https的可以直接使用安官方文档使用css文件路径
    //     const appid = "wxd888b4544479f3af";
    //     const redirect_uri = encodeURIComponent(
    //         "https://golfreservations.club/login"
    //     );

    //     let loginObj = new WxLogin({
    //         id: "wxlogin", //div的id
    //         appid: appid,
    //         scope: "snsapi_login", //固定内容
    //         redirect_uri: redirect_uri, //回调地址
    //         // href: "http://*/static/UserCss/WeChart.css" //自定义样式链接，第三方可根据实际需求覆盖默认样式。
    //         //href: "data:text/css;base64," + ba64Css
    //         // state: "", //参数，可带可不带
    //         // style: "", //样式  提供"black"、"white"可选，默认为黑色文字描述
    //     });
    // }
    // 只是参数发生变化监听不到，放弃
    @Watch("$route")
    async RouteChange(to, from) {
        //await this.weixinRedirect();
    }
    userRules = {
        phoneNumber: [
            {
                required: true,
                message: "请输入手机号",
                trigger: "blur",
            },
            {
                pattern:
                    /(^1[3456789]\d{9}$)|(^(0[0-9]{2,3}\-)?([2-9][0-9]{6,7})+(\-[0-9]{1,6})?$)/,
                message: this.L(
                    "IncorrectFormat",
                    undefined,
                    this.L("PhoneNumber")
                ),
                trigger: "blur",
            },
        ],
        code: [
            {
                required: true,
                message: "请输入验证码",
                trigger: "blur",
            },
        ],
    };
    async weixinRedirect() {
        let code = this.$route.query.code;
        let state = this.$route.query.state;

        if (code) {
            const loginModel = {
                authProvider: "WechatMiniProgram",
                providerKey: "sunlit",
                rememberMe: true,
                providerAccessCode: code,
            };
            this.$Message.loading({
                content: this.L("LoginPrompt"),
                duration: 0,
            });
            await this.$store
                .dispatch({
                    type: "app/wxScanLogin",
                    data: loginModel,
                })
                .then((res) => {
                    //不管code等于几都要写为缓存里面
                    sessionStorage.setItem("rememberMe", "1");
                    if (res && res.data && res.data.result) {
                        //如果code==1则直接登录成功
                        this.code = res.data.result.code;
                        if (res.data.result.code == 1) {
                             const url= window.localStorage.getItem('detail');
                            if (url) {
                                window.location.href = url;
                                window.localStorage.removeItem('detail')
                            } else {
                                this.$router.push({
                                    name: "fronthome"
                                })
                            }
                       this.$Message.destroy();

                        } else if (this.code == 2 || this.code == 3) {
                            this.$Message.destroy();

                            //不管新老用户，都需要绑定手机号
                            if (this.code == 3) {
                                this.userInfo = res.data.result.userInfo;
                            }
                            this.bindPhoneModal = true;
                        }
                    }
                });
            return;

            // await this.$store.dispatch({
            //     type: "session/init"
            // });
        }
    }
    get tenant() {
        return this.$store.state.session.tenant;
    }
    rules = {
        userNameOrEmailAddress: [
            {
                required: true,
                message: this.L("UserNameRequired"),
                trigger: "blur",
            },
        ],
        password: [
            {
                required: true,
                message: this.L("PasswordRequired"),
                trigger: "blur",
            },
        ],
    };
    /**
     * @description:组件回调
     */
    goRoutet() {
        let routeName = "fronthome";
        let isRegister = this.$store.state.session.user.isRegister;

        if (this.$store.state.session.user && isRegister === false) {
            routeName = "home";
        }
        this.$router.push({ name: routeName });
        this.$Message.destroy();
    }
    created() {
        let code = this.$route.query.code;
        let url = this.$route.query.url;

        if (code) {
            this.weixinRedirect();
        }
        if(url){
            this.url = url;
        }
    }
    mounted() {
        let domHtml = document.querySelector("html");
        domHtml.style.height = "100%";
        domHtml.style.width = "100%";
        let domBody = document.querySelector("body");
        domBody.style.height = "100%";
        domBody.style.width = "100%";
        let domApp = document.getElementById("app");
        domApp.style.height = "100%";

        // 加载微信扫码登录js文件
        // const wxJs = document.createElement("script");
        // wxJs.type = "text/javascript";
        // wxJs.src =
        //     "http://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js";
        // document.body.appendChild(wxJs);
        // this.wechatHandleClick();
    }

    //把绑定手机号从home迁移到这里(2和3的时候 跳转逻辑应该放到领取新人优惠券后触发的事件里面，这里还未完成)
    //绑定手机号还未加表单验证
    async bindPhoneHandle() {
        (this.$refs.bindPhoneForm as any).validate(async (valid: boolean) => {
            if (valid) {
                if (this.code == 2) {
                    const params = {
                        phoneNumber: this.user.phoneNumber,
                        bindCode: this.user.code,
                    };
                    Ajax.post("/api/TokenAuth/BindMobile", params).then(
                        (res) => {
                            this.$Message.success({
                                content: `绑定手机号成功`,
                            });
                            this.$store.dispatch('session/init').then(res=>{
                                this.bindPhoneModal = false;
                                 const url = window.localStorage.getItem('detail');
                                if (url) {
                                    window.location.href = url;
                                    window.localStorage.removeItem('detail')
                                } else {
                                    this.$router.push({
                                        name: "fronthome"
                                    })
                                }
                                this.$Message.destroy();
                            })
                        }
                    );
                } else if (this.code == 3) {
                    const params = {
                        phoneNumber: this.user.phoneNumber,
                        code: this.user.code,
                        userInfo: this.userInfo,
                    };
                    Ajax.post("/api/TokenAuth/BindOrLogin", params).then(
                        (res) => {
                            this.$Message.success({
                                content: `绑定手机号成功`,
                            });
                            //code==3的时候 要替换token
                            if (res.data.result) {
                                Util.abp.auth.setToken(
                                    res.data.result.accessToken
                                );
                                Util.abp.utils.setCookieValue(
                                    appconst.authorization
                                        .encrptedAuthTokenName,
                                    res.data.result.encryptedAccessToken,
                                    undefined,
                                    Util.abp.appPath
                                );
                                  this.$store.dispatch('session/init').then(() => {
                                    this.bindPhoneModal = false;
                                    if (res && res.data && res.data.result && res.data.result.code == 4) {
                                        this.isShow = true;
                                        return;
                                    }
                                     const url = window.localStorage.getItem('detail');
                                    if (url) {
                                        window.location.href = url;
                                        window.localStorage.removeItem('detail')
                                    } else {
                                        this.$router.push({
                                            name: "fronthome"
                                        })
                                    }
                                    this.$Message.destroy();
                                  })
                            }
                          
                        }
                    );
                }
            } else {
                this.$Message.error({
                    content: "输入格式不正确,请重新输入",
                });
            }
        });
    }
    getVerifyCode() {
        if (this.user.phoneNumber == "") {
            this.$Modal.error({
                title: "提示信息",
                content: "请输入手机号",
            });
            return;
        }
        if (
            !/(^1[3456789]\d{9}$)|(^(0[0-9]{2,3}\-)?([2-9][0-9]{6,7})+(\-[0-9]{1,6})?$)/.test(
                this.user.phoneNumber
            )
        ) {
            this.$Modal.error({
                title: "提示信息",
                content: "号码格式不正确",
            });
            return;
        }

        let countDown: any = null;
        if (this.code == 2) {
            Ajax.post("/api/TokenAuth/SendBindMobileCode", {
                phoneNumber: this.user.phoneNumber,
            }).then((res) => {
                this.cutDown();
            });
        } else if (this.code == 3) {
            Ajax.post("/api/TokenAuth/SendBindOrLoginCaptcha", {
                phoneNumber: this.user.phoneNumber,
            }).then((res) => {
                this.cutDown();
            });
        }
    }
    cutDown() {
        //倒计时
        let time = 60;
        let timer = setInterval(() => {
            if (time == 0) {
                clearInterval(timer);
                this.disabled = false;
                this.content = "获取验证码";
            } else {
                this.content = time + "秒后重试";
                this.disabled = true;
                time--;
            }
        }, 1000);
    }
}
